<template>
  <div class="MyAdmin">
    <v-container fill-height fluid>
      <v-row> </v-row>

      <v-row no-gutters justify="start">
        <!-- sidebar col -->

        <v-col cols="2">
          <!-- <v-spacer /> -->
          <v-app-bar-nav-icon
            @click.stop="drawer = !drawer"
            class=""
          ></v-app-bar-nav-icon>
          <v-navigation-drawer
            v-model="drawer"
            :permanent="$vuetify.breakpoint.lgAndUp"
            :temporary="$vuetify.breakpoint.mdAndDown"
            absolute
            class=""
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title"> My Admin </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider> </v-divider>
            <v-list dense nav>
              <v-list-item
                v-for="item in items"
                :key="item.id"
                :to="item.route"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider> </v-divider>
            <v-list dense nav>
              <v-list-item
                v-for="item in financeItems"
                :key="item.id"
                :to="item.route"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider> </v-divider>
            <v-list dense nav>
              <v-list-item
                v-for="item in depotItems"
                :key="item.id"
                :to="item.route"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider> </v-divider>
            <v-list dense nav>
              <v-list-item
                v-for="item in textItems"
                :key="item.id"
                :to="item.route"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-col>

        <v-col>
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  methods: {
    getCookie: function (name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
    fetchTranslations: function () {
      this.$api
        .get(this.$store.state.pathDepth + "lang/app_wide_text.json")
        .then((response) => {
          //   // console.log(response);
          this.transTest = response.data;
        });
    },
  },
  created: function () {
    this.getCookie("recup_lang");
    this.fetchTranslations();
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  data() {
    return {
      drawer: true,
      transTest: null,
      search: "",
      // session: "",
      // test: "",
      sortBy: "any_new",
      sortDesc: true,
      // tab: null,
      items: [
        { id: 1, name: "Users", icon: "fa-user-friends", route: "/adminUsers" },
        {
          id: 2,
          name: "Organizations",
          icon: "fa-hands-helping",
          route: "/adminOrganizations",
        },
      ],

      financeItems: [
        { id: 1, name: "Categories", icon: "fa-table", route: "/priceList" },
        {
          id: 2,
          name: "Platform Summaries",
          icon: "fa-chart-bar",
          route: "/statsPlatform",
        },
        {
          id: 3,
          name: "Org Summaries",
          icon: "fa-chart-pie",
          route: "/statsOrgs",
        },
      ],
      depotItems: [
        {
          id: 1,
          name: "Depot In",
          icon: "fa-warehouse",
          route: "/depotIn",
        },
        {
          id: 2,
          name: "Depot Out",
          icon: "fa-warehouse",
          route: "/depotOut",
        },
        {
          id: 3,
          name: "Depot Overview",
          icon: "fa-warehouse",
          route: "/depotOverview",
        },
      ],
      textItems: [
        { id: 1, name: "Website Text", icon: "fa-file-alt", route: "/webText" },
        {
          id: 2,
          name: "Newsletter",
          icon: "fa-envelope-open-text",
          route: "/newsLetter",
        },
        {
          id: 2,
          name: "Exporter",
          icon: "fa-envelope-open-text",
          route: "/exporter",
        },
      ],
    };
  },
};
</script>
